<template>
    <v-app>
        <app-header :logo="logo" :sidebar="sidebar_data != undefined" :query="query" @sidebar='() => drawer = !drawer'
            :settings="settings" :infos="infos">
            <template #title>
                {{ title }}
            </template>
        </app-header>
        <v-navigation-drawer v-if="sidebar_data != undefined" :rail="rail" :permanent="md" width="320"
            :disable-route-watcher="true" :stateless="true" :modelValue="cdrawer" @update:modelValue="update_cdrawer">
            <keep-alive>
                <component v-if="!rail && sidebar_data != undefined" :is="sidebar" :data='sidebar_data' @navigate="navigate" />
            </keep-alive>
            <keep-alive>
                <component v-if="rail && sidebar_data != undefined" :is="sidebar_small" :data='sidebar_data'
                    @navigate="navigate" />
            </keep-alive>
        </v-navigation-drawer>
        <slot name="appbar"></slot>
    </v-app>
</template>

<script>
import AppHeader from './AppHeader.vue';
import SideBar from './SideBar.vue';
import SideBarSmall from './SideBarSmall.vue';

export default {
    name: 'TemplateApp',
    components: {
        AppHeader,
    },
    props: {
        title: String,
        logo: String,
        sidebar: {
            type: Object,
            default: SideBar,
        },
        sidebar_small: {
            type: Object,
            default: SideBarSmall,
        },
        sidebar_data: Object,
        query: {
            type: Object,
            default: undefined,
        },
        settings: Function,
        infos: Array,
    },
    data() {
        return {
            drawer: true,
        };
    },
    computed: {
        display() {
            return this.$vuetify.display;
        },
        md() {
            return this.display.mdAndUp;
        },
        xs() {
            return this.display.xs;
        },
        cdrawer() {
            if (this.md) {
                return true;
            }
            return this.drawer;
        },
        rail() {
            if (this.md) {
                return !this.drawer;
            }
            return false;
        },
    },
    mounted() {
        this.drawer = this.md;
    },
    methods: {
        update_cdrawer(e) {
            this.drawer = e;
        },
        navigate(payload) {
            if (!this.md) {
                this.drawer = false;
            }
            this.$router.push(payload);
        },
    },
};
</script>

<style>
.align-items-center {
    align-items: center;
}

.btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition:
        color .15s ease-in-out,
        background-color .15s ease-in-out,
        border-color .15s ease-in-out,
        box-shadow .15s ease-in-out;
}
</style>
